module.exports = __webpack_public_path__ + "img/1 (91).23be9419.png";